/**
 * Home hero backdrop.
 * Site-wide fluid particle background is provided by <FluidBackground /> in App.js.
 * Here we just add a soft fade at the bottom to blend the hero into the next section.
 */
export default function HeroBackdrop() {
  return (
    <div className='absolute inset-0 overflow-hidden pointer-events-none'>
      <div className='absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-void z-10' />
    </div>
  );
}
